import React, { Component } from 'react'
import RecommendationUI from './RecommendationUI.js'

class RecommendationSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    return (
      <RecommendationUI
        context={this.props.context}
        loan={this.props.loan}
        loanFeasibility={this.props.loanFeasibility}
        feasibilityItemList={this.props.feasibilityItemList}
        failed={this.props.failed}
        total={this.props.total}
        failedSmallLoan={this.props.failedSmallLoan}
        totalSmallLoan={this.props.totalSmallLoan}
        onRefreshClick={this.props.onRefreshClick}
      />
    )
  }
}

export default RecommendationSF
